window.htmx = require('htmx.org');
